import React from 'react';
import withLoading from 'Layout/withLoading';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import Layout from 'Layout/Layout';
import { withLocale } from '@dietlabs/components';
import { Container } from 'reactstrap';
import HpbaMarkdown from 'Content/utils/HpbaMarkdown';
import ContentPlaceholder from './ContentPlaceholder';

class DietFaq extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        content: PropTypes.shape({
            content: PropTypes.shape({
                html: PropTypes.string,
                markdown: PropTypes.string,
            }),
        }).isRequired,
    };

    render() {
        return (
            <Layout page="cms-article">
                <Helmet>
                    <title>
                        Pytania i odpowiedzi ✓ Oficjalna Dieta dr Ewy
                        Dąbrowskiej®
                    </title>
                    <meta
                        name="description"
                        content="Czy dieta dr Dąbrowskiej przeznaczona jest wyłącznie dla osób, które chcą schudnąć? Czy post Daniela nie powoduje efektu jo-jo? I 9 innych | Od 49,99 zł/mc"
                    />
                </Helmet>

                <Container>
                    <header>
                        <h1>{this.props.t('diet-faq/title')}</h1>
                    </header>
                    <section className="pt-0">
                        <div className="cms-content">
                            <HpbaMarkdown
                                content={this.props.content.content.markdown}
                            />
                        </div>
                    </section>
                </Container>
            </Layout>
        );
    }
}

export default withLoading(withLocale(DietFaq), ContentPlaceholder);
